import Page from "components/Page/Page";
import Hero from "./components/Hero/Hero";
import OfficialPartners from "components/OfficialPartners/OfficialPartners";
import WhyChooseUs from "./components/WhyChooseUs/WhyChooseUs";
import HowItWorks from "./components/HowItWorks/HowItWorks";
import Plans from "components/Plans/Plans";
import OverBusinessesUse from "./components/OverBusinessesUse/OverBusinessesUse";
import FrequentlyQuestions from "components/FrequentlyQuestions/FrequentlyQuestions";
import GetStartedToday from "components/GetStartedToday/GetStartedToday";

const Home = () => {
	return (
		<Page title="Home">
			<Hero />
			<OfficialPartners />
			<WhyChooseUs />
			<HowItWorks />
			<Plans />
			<OverBusinessesUse />
			<FrequentlyQuestions />
			<GetStartedToday />
		</Page>
	);
};

export default Home;
